import * as go from 'gojs';
import noop from 'lodash/noop';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { shapeNodeTemplate } from '../shape-node';

export const setupShapeNode = (diagram: go.Diagram, categoryName: string) => {
  registerNodeTemplate(diagram, categoryName, shapeNodeTemplate());
  return noop;
};
